import * as Types from '../../../../api/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type OnVisitorUpdateSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type OnVisitorUpdateSubscription = { __typename?: 'Subscription', OnVisitorUpdate: { __typename?: 'Visitor', _id: string, type: Types.AuthenticationType, name?: string | null, email?: string | null, image?: string | null } };


export const OnVisitorUpdateDocument = gql`
    subscription OnVisitorUpdate {
  OnVisitorUpdate {
    _id
    type
    name
    email
    image
  }
}
    `;

/**
 * __useOnVisitorUpdateSubscription__
 *
 * To run a query within a React component, call `useOnVisitorUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnVisitorUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnVisitorUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnVisitorUpdateSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<OnVisitorUpdateSubscription, OnVisitorUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnVisitorUpdateSubscription, OnVisitorUpdateSubscriptionVariables>(OnVisitorUpdateDocument, options);
      }
export type OnVisitorUpdateSubscriptionHookResult = ReturnType<typeof useOnVisitorUpdateSubscription>;
export type OnVisitorUpdateSubscriptionResult = ApolloReactCommon.SubscriptionResult<OnVisitorUpdateSubscription>;